<template>
  <div class="head headDefault" :class="headBg ? 'headBg' : ''">
    <div class="head-main">
      <div class="head-left">
        <div class="head-icon">
          <img @click="goHome()" src="../assets/img/logo-head.png" alt />
        </div>
      </div>
      <div class="head-right">
        <div class="head-rightTop">
          <ul>
            <router-link class="topNav help_tab" to="/help" tag="li"
              >帮助中心</router-link
            >
            <router-link class="topNav download_tab" to="/download" tag="li"
              >app下载</router-link
            >
            <li class="topNav">
              <a :href="adminApl" target="_blank">服务商登录</a>
            </li>
            <li class="topNav" v-if="$store.state.login">
              <img
                :src="
                  !$store.state.userAvatar
                    ? defaultAvatar
                    : $store.state.userAvatar
                "
                @click="openOrderList()"
                alt
              />
              <div @click="openOrderList()">{{ $store.state.userName }}</div>
              <span @click="logout()">退出</span>
            </li>

            <router-link
              class="topNav user-register"
              to="/register"
              tag="li"
              v-if="!$store.state.login"
              >下单注册</router-link
            >
            <router-link
              class="topNav user-login"
              to="/login"
              tag="li"
              v-if="!$store.state.login"
              >下单登录</router-link
            >
            <!-- <li @click="pageDevelopment" class="topNav">服务商登录</li> -->
            <!-- <li @click="pageDevelopment" class="topNav">下单注册</li>
            <li @click="pageDevelopment" class="topNav">下单登录</li> -->
          </ul>
        </div>
        <div class="head-rightBottom">
          <router-link to="/about" class="bottomNav about" exact tag="li"
            >关于我们</router-link
          >
          <router-link
            to="/service_ruzhu"
            class="bottomNav service_ruzhu"
            exact
            tag="li"
            >服务商入驻</router-link
          >
          <router-link to="/ruzhu" class="bottomNav ruzhu" exact tag="li"
            >师傅入驻</router-link
          >
          <router-link to="/baozhang" class="bottomNav baozhang" exact tag="li"
            >服务保障</router-link
          >
          <router-link to="/fangan" class="bottomNav fangan" exact tag="li"
            >解决方案</router-link
          >
          <router-link to="/" class="bottomNav shouye" exact tag="li"
            >首页</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headBg: false,
      login: false,
      defaultAvatar: require("@/assets/img/pic_head_nor.png"),
      adminApl: process.env.VUE_APP_ADMIN_API
    };
  },
  mounted() {
    var _this = this;
    //页面加载完成
    this.initComplete();
    if ($.trim(Cookies.get("token")) != "") {
      this.$store.state.login = true;
    } else {
      this.$store.state.login = false;
    }
  },
  methods: {
    // 页面开发
    pageDevelopment() {
      this.$message("功能即将上线");
    },
    goHome() {
      this.$router.push({ path: "/" });
    },
    //页面加载完成
    initComplete() {
      let timer = 0;
      this.$nextTick(() => {
        this.homeBanner = true;
        this.getScrollInitTop();
      });
      window.addEventListener("scroll", this.handleScroll);
    },
    //获取页面初始化时的高度
    getScrollInitTop() {
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(top);
      top = parseInt(top);
      if (top > 0) {
        this.headBg = true;
      }
    },
    //页面滚动事件
    handleScroll() {
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(top);
      top = parseInt(top);
      if (top > 0) {
        this.headBg = true;
      }
      if (top === 0) {
        this.headBg = false;
      }
    },
    // 退出登录
    logout() {
      this.$confirm("你确定要退出聚师傅吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$message({
          type: "success",
          message: "退出成功!"
        });
        this.$store.state.login = false;
        Cookies.remove("token", { path: "/" });
      });
    },
    openOrderList() {
      this.$router.push({ path: "/user/index" });
    }
  }
};
</script>

<style lang="scss">
@import "./_headTop.scss";
</style>
